import { render, staticRenderFns } from "./BotPartBubble.vue?vue&type=template&id=73f995c8&scoped=true"
import script from "./BotPartBubble.vue?vue&type=script&lang=js"
export * from "./BotPartBubble.vue?vue&type=script&lang=js"
import style0 from "./BotPartBubble.vue?vue&type=style&index=0&id=73f995c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f995c8",
  null
  
)

export default component.exports